module.exports = __webpack_public_path__ + "1ddd251b6e046fba8647b4b1a6ad55c2.svg";